import { testimonials } from "@/mocks/site";
import SectionHeading from "@/components/base/SectionHeading";

export default function VoiceSection() {
  return (
    <section className="border-b border-background-200 bg-background-50 px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="读者怎么说"
        title="他们把这里当成背景资料库"
        desc="来自读者反馈的整理，内容原则始终是：只呈现公开信息，剩下的交给你判断。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100/60 p-5"
          >
            <i className="ri-double-quotes-l text-2xl text-accent-300"></i>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.content}
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm text-primary-800">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm text-foreground-900">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}